import { Button, Header, Icon } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext, useEffect } from 'react'
import { StoreContext } from '@store/Root.store'
import { getUrlParam } from '@/methods/urlParams'
import { cx } from '@/utils/cx'

export const VideoOnboardingPage = observer(() => {
  const store = useContext(StoreContext)
  const { context } = store.ScenarioState
  const docType = getUrlParam('docType')

  const { videoOnboardingPage: trans } = store.TranslationsState.translations

  const handleProceed = async () => {
    store.ScenarioState.nextPage()
  }

  useEffect(() => {
    if (!context?.showVideoIdHintsScreen) {
      store.ScenarioState.skipStep()
    }
  }, [])

  return (
    <div className="page-container">
      <Header>{trans.header}</Header>

      <div className="generic__onboarding-list">
        <div className="generic__onboarding-item">
          <div className="generic__onboarding-icon">
            <Icon type="bulb" size="32px" />
          </div>
          <span className="generic__onboarding-single-line">{trans.wellLitPlace}</span>
        </div>
        <div className="generic__onboarding-item">
          <div className="generic__onboarding-icon">
            <Icon type="identity-card" size="32px" />
          </div>
          <span className="generic__onboarding-single-line">{trans.originalDocument}</span>
        </div>
        <div className="generic__onboarding-item">
          <div className="generic__onboarding-icon">
            <Icon type="globe" size="32px" />
          </div>
          <span className="generic__onboarding-single-line">{trans.wifi} </span>
        </div>
      </div>

      <div className="layout__content-container-bottom-fixed">
        <div className="layout__content-container-bottom-left" />
        <Button
          onClick={() => handleProceed()}
          disabled={context?.shouldSelectDocument ? !(docType && docType.length) : false}
        >
          <span className="generic__button-text">{trans.start}</span>
        </Button>
      </div>
    </div>
  )
})
